import axios from 'axios';
import url from '@/utils/api.js';
import { useRouter } from 'vue-router';

const router = useRouter();

// 路由数据
// 第一个axios实例，用于API请求
const apiClient = axios.create({
    baseURL: url.api.Base_URL, // API基础URL
    withCredentials: true // 如果需要跨域请求凭证，请设置为true
})

// 请求拦截器，用于在请求发出之前做一些处理
apiClient.interceptors.request.use(
    config => {
        // 假设我们有一些不需要token的路径或条件
        const noTokenRequiredPaths = ['/auth/login/local/', '/auth/register/','/auth/captcha/','/auth/captcha_verify/','/auth/sms_code/']; // 不需要token的路径列表
        const isNoTokenRequired = noTokenRequiredPaths.some(path => config.url.includes(path));

        if (!isNoTokenRequired) { // 只有当请求不在不需要token的路径列表中时，才尝试添加token
            const token = localStorage.getItem('token'); // 假设你将token存储在localStorage中
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`; // 添加token到请求头
            } else {
                // 如果没有token，重定向到oa系统
                if (localStorage.getItem("type")=='1') {
                    window.location.href = url.api.OA_URL;//退出之后返回oa系统
                } else {
                    router.replace({ name: "login" }); //菜单栏路由跳转登录页
                }
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// 响应拦截器（可选），处理响应错误，例如token失效的情况
apiClient.interceptors.response.use(response => {
    // 检查 status 为 200 并且 res.data.code 为 1003 的情况
    if (response.data.code === 1003) {
        // 如果没有token，重定向到oa系统
        if (localStorage.getItem("type")=='1') {
            window.location.href = url.api.OA_URL;//退出之后返回oa系统
        } else {
            router.replace({ name: "login" }); //菜单栏路由跳转登录页
        }
        // 清除浏览器存储信息---全部清除
        localStorage.clear();
        sessionStorage.clear();
    } else {
        return response; // 如果不符合条件，则正常返回响应
    }
},
error => {
    // 错误响应处理逻辑
    if (error.response) {
        // 请求已发出，但服务器响应的状态码不在 2xx 范围内
        if (error.response.status === 401) { // 假设401代表未授权或token失效
            // 如果没有token，重定向到oa系统
            if (localStorage.getItem("type")=='1') {
                window.location.href = url.api.OA_URL;//退出之后返回oa系统
            } else {
                router.replace({ name: "login" }); //菜单栏路由跳转登录页
            }
            // 清除浏览器存储信息---全部清除
            localStorage.clear();
            sessionStorage.clear();
        }else if(error.response.status === 404){
            // 404错误，可能是请求路径错误
            const notFoundError = new Error('未找到请求路径');
            notFoundError.isNotFoundError = true; // 自定义属性，用于区分404错误
            return Promise.reject(notFoundError); // 返回自定义错误对象
        }else if(error.response.status === 500){
            // 500错误，可能是服务器内部错误
            const serverError = new Error('服务器内部错误，请联系管理员。');
            serverError.isServerError = true; // 自定义属性，用于区分服务器错误
            return Promise.reject(serverError); // 返回自定义错误对象
        }
    } else {
        // 请求未发出或其它网络错误发生
        const networkError = new Error('服务器连接失败，请检查您的网络设置并重试。');
        networkError.isNetworkError = true; // 自定义属性，用于区分网络错误
        return Promise.reject(networkError); // 返回自定义错误对象
    }
})


export { apiClient };
